"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistSkeleton = void 0;

require("react-loading-skeleton/dist/skeleton.css");

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _index = require("../../index");

require("./PlaylistSkeleton.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

// Playlist Skeleton
var PlaylistSkeleton = function PlaylistSkeleton(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_react.default.createElement(_index.Column, {
    className: "PlaylistSkeleton",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_index.Row, {
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    className: "avatar-skeleton",
    baseColor: "#F2F2F2"
  }), /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    className: "user-name-skeleton",
    baseColor: "#D8D8D8"
  })), /*#__PURE__*/_react.default.createElement(_index.Row, {
    className: "playlist",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    className: "color-square-skeleton",
    baseColor: "#F2F2F2"
  }), /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    className: "playlist-title-skeleton",
    baseColor: "#D8D8D8"
  })), /*#__PURE__*/_react.default.createElement(_index.Row, {
    className: "playlist",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    className: "color-square-skeleton",
    baseColor: "#F2F2F2"
  }), /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    className: "playlist-title-skeleton",
    baseColor: "#D8D8D8"
  })));
};

exports.PlaylistSkeleton = PlaylistSkeleton;